import { Route, Routes } from "react-router-dom";
import { Space } from "~/lib/types";
import { GeneralSpaceSettings } from "~/pages/space-settings/general-settings";
import { GenerateApiTokenForm } from "~/pages/space-settings/api-tokens/generate-api-token-form";
import { AuditLog } from "~/pages/space-settings/settings-auditlog";
import { Members } from "~/pages/space-settings/settings-members";
import { RegistrationTokensPage } from "~/pages/space-settings/settings-registration-tokens";
import { ApiTokensPage } from "~/pages/space-settings/api-tokens/settings-api-tokens";
import { GenerateServiceAccountsForm } from "~/pages/organization/settings/service-accounts-form";
import { ServiceAccounts } from "~/pages/organization/settings";
import { OrganizationSettingsTickets } from "~/pages/organization/settings/OrganizationSettingsTickets";
import { SpaceOrWorkspaceScope } from "~/hooks/useScope";
import { WorkloadIdentity } from "~/pages/space-settings/WorkloadIdentity";
import { WorkloadIdentityProvidersList } from "~/pages/space-settings/WorkloadIdentity/components/WorkloadIdentityProvidersList";
import { WorkloadIdentityProviderForm } from "~/pages/space-settings/WorkloadIdentity/components/WorkloadIdentityProviderForm";
import { SpaceSettings } from "~/pages/space/SpaceSettings/SpaceSettings";

type Props = {
  space: Space;
  scope: SpaceOrWorkspaceScope;
};

export function SettingsRoutes({ space, scope }: Props) {
  return (
    <Routes>
      <Route element={<SpaceSettings space={space} />}>
        <Route index element={<GeneralSpaceSettings />} />
        <Route path="general" element={<GeneralSpaceSettings />} />
        <Route
          path="tickets"
          element={<OrganizationSettingsTickets space={space} scope={scope} />}
        />
        <Route path="members/*" element={<Members />} />
        <Route path="auditlog" element={<AuditLog {...{ space }} />} />
        <Route
          path="serviceaccounts"
          element={<ServiceAccounts {...{ space }} />}
        />
        <Route
          path="serviceaccounts/add"
          element={<GenerateServiceAccountsForm {...{ space }} />}
        />
        <Route
          path="registration-tokens"
          element={<RegistrationTokensPage {...{ space }} />}
        />
        <>
          <Route path="workload-identity">
            <Route index element={<WorkloadIdentity {...{ space }} />} />
            <Route path="providers">
              <Route
                index
                element={<WorkloadIdentityProvidersList scope={space} />}
              />
              <Route
                path="add/:type"
                element={<WorkloadIdentityProviderForm scope={space} />}
              />
            </Route>
          </Route>
        </>
        <Route path="api-tokens" element={<ApiTokensPage {...{ space }} />} />

        <Route
          path="api-tokens/add"
          element={<GenerateApiTokenForm {...{ space }} />}
        />
      </Route>
    </Routes>
  );
}
